import { render } from "./ProductConfigurableChoices.vue?vue&type=template&id=0f98c516"
import script from "./ProductConfigurableChoices.vue?vue&type=script&lang=js"
export * from "./ProductConfigurableChoices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__